/* global zaraz */
import React from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import { apiFetchData, apiPostData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import { dispatchTrackingEvent, CONSENT_BUTTONS_UPDATE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';

export default class ZarazConsent extends React.Component {
    constructor(props) {
        super(props);
        this.pathExtension = 'cookie-settings/';
        this.postPathExtension = 'log/cookie-consent-counter';
        this.state = {
            marketingConsent: false,
            functionalConsent: false,
            essentialConsent: true,
            isEssentialOpen: false,
            isMarketingOpen: false,
            isFunctionalOpen: false,
            isOptionsOpen: false,
            showConsentModal: false,
            publicResources: null,
            errorMsg: null,
        };
        this.getData = this.getData.bind(this);
        this.openModal = this.openModal.bind(this);
    }

    componentDidMount() {
        if (!this.canPersist()) {
            this.handleRejectAll();
            return;
        }
        const consentCookie = this.getCookie('zaraz-consent');
        if (!consentCookie) {
            this.getData();
        } else {
            this.loadConsentSettings();
            this.sendClarityConsentForExistingUser();
        }
        window.addEventListener('openConsentModal', this.openModal);
    }

    componentWillUnmount() {
        window.removeEventListener('openConsentModal', this.openModal);
    }

    getData() {
        const stateData = this.state;
        if (!stateData.publicResources) {
            this.setState({ isLoading: true });
            apiFetchData(this.pathExtension)
                .then((res) => {
                    if (res.status === 200) {
                        this.setState({
                            publicResources: res.data,
                            showConsentModal: true,
                        });
                        return;
                    }
                    reportError(res);
                })
                .catch((err) => {
                    this.setState({
                        errorMsg: err,
                        isLoading: false,
                    });
                    reportError(err);
                })
                .finally(() => {
                    this.setState({
                        isLoading: false,
                    });
                });
        }
    }

    handleSave = () => {
        const { marketingConsent, functionalConsent } = this.state;
        if (!IS_FRAME_SERVICE) dispatchTrackingEvent(CONSENT_BUTTONS_UPDATE, { consent_action: 'save' });
        if (typeof zaraz !== 'undefined' && zaraz.consent && !IS_FRAME_SERVICE) {
            zaraz.consent.set({ KlIi: marketingConsent });
            zaraz.consent.set({ ulGI: functionalConsent });
            zaraz.set('google_consent_update', {
                ad_storage: marketingConsent ? 'granted' : 'denied',
                ad_user_data: marketingConsent ? 'granted' : 'denied',
                ad_personalization: marketingConsent ? 'granted' : 'denied',
                analytics_storage: marketingConsent ? 'granted' : 'denied',
            });
            zaraz.consent.sendQueuedEvents();
            if (typeof window.clarity !== 'undefined') {
                window.clarity('consentv2', {
                    ad_Storage: marketingConsent ? 'granted' : 'denied',
                    analytics_Storage: marketingConsent ? 'granted' : 'denied',
                });
            }
        }
        this.setCookieConsent();
        this.setState({ showConsentModal: false });
        const requestBody = { type: 'modified' };
        this.postData(requestBody);
    };

    handleRejectAll = () => {
        this.setState({ showConsentModal: false });
        if (!IS_FRAME_SERVICE) dispatchTrackingEvent(CONSENT_BUTTONS_UPDATE, { consent_action: 'reject_all' });
        if (typeof zaraz !== 'undefined' && zaraz.consent && !IS_FRAME_SERVICE) {
            zaraz.consent.set({ KlIi: false });
            zaraz.consent.set({ ulGI: false });
            zaraz.set('google_consent_update', {
                ad_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                analytics_storage: 'denied',
            });
            if (typeof window.clarity !== 'undefined') {
                window.clarity('consentv2', {
                    ad_Storage: 'denied',
                    analytics_Storage: 'denied',
                });
            }
        }
        this.setState({
            marketingConsent: false,
            functionalConsent: false,
        });
        this.setCookieConsent();
        const requestBody = { type: 'decline' };
        this.postData(requestBody);
    };

    handleOptions = () => {
        const { isOptionsOpen } = this.state;
        this.setState({ isOptionsOpen: !isOptionsOpen });
    };

    handleAcceptAll = () => {
        if (!IS_FRAME_SERVICE) dispatchTrackingEvent(CONSENT_BUTTONS_UPDATE, { consent_action: 'accept_all' });
        if (typeof zaraz !== 'undefined' && zaraz.consent && !IS_FRAME_SERVICE) {
            zaraz.consent.setAll(true);
            zaraz.set('google_consent_update', {
                ad_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted',
                analytics_storage: 'granted',
            });
            zaraz.consent.sendQueuedEvents();
            if (typeof window.clarity !== 'undefined') {
                window.clarity('consentv2', {
                    ad_Storage: 'granted',
                    analytics_Storage: 'granted',
                });
            }
        }
        this.setState({
            marketingConsent: true,
            functionalConsent: true,
        });
        this.setCookieConsent();
        this.setState({ showConsentModal: false });
        const requestBody = { type: 'accept' };
        this.postData(requestBody);
    };

    // TODO: Disable-ano samo zbog toga što je u planu refactor klasnih komponenti.
    // eslint-disable-next-line class-methods-use-this
    setCookieConsent = () => {
        document.cookie = 'zaraz-consent=true; path=/';
    };

    getCookie(name) { // eslint-disable-line class-methods-use-this
        const value = `; ${document.cookie}`;
        return value?.split(`; ${name}=`)[1]?.split(';')[0];
    }

    loadConsentSettings = () => {
        if (typeof zaraz !== 'undefined' && zaraz.consent && !IS_FRAME_SERVICE) {
            const marketingConsent = zaraz.consent.get('KlIi');
            const functionalConsent = zaraz.consent.get('ulGI');
            this.setState({
                marketingConsent: marketingConsent || false,
                functionalConsent: functionalConsent || false,
            });
        }
    };

    canPersist = () => { // eslint-disable-line class-methods-use-this
        try {
            const key = '__test-key__';
            localStorage.setItem(key, '1');
            localStorage.removeItem(key);
            document.cookie = `${key}=1; path=/`;
            const hasCookie = document.cookie.includes(key);
            document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
            return hasCookie;
        } catch {
            return false;
        }
    };

    openModal = () => {
        const { publicResources } = this.state;
        if (publicResources) {
            this.setState({ isOptionsOpen: true, showConsentModal: true });
        } else {
            this.getData();
        }
    };

    sendClarityConsentForExistingUser() { // eslint-disable-line class-methods-use-this
        if (typeof zaraz === 'undefined' || IS_FRAME_SERVICE) return;
        if (typeof window.clarity !== 'function') return;

        const marketingConsent = zaraz.consent.get('KlIi') || false;

        window.clarity('consentv2', {
            ad_Storage: marketingConsent ? 'granted' : 'denied',
            analytics_Storage: marketingConsent ? 'granted' : 'denied',
        });
    }

    postData(bodyData) {
        apiPostData(this.postPathExtension, bodyData)
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.validationErrorMessages) {
                        this.setState({
                            errorValidationMsg: res.data,
                            isFormValid: false,
                        }, () => { this.handleFeedbackErrors(); });
                        return;
                    }
                    this.setState({
                        errorValidationMsg: null,
                        postResponseData: res.data,
                    });
                    return;
                }
                reportError(res);
            })
            .catch((err) => {
                this.setState({
                    isFormValid: false,
                });
                reportError(err);
            });
    }

    toggleSection(section) {
        this.setState((prevState) => ({
            [section]: !prevState[section],
        }));
    }

    render() {
        const { marketingConsent, functionalConsent, isEssentialOpen, isMarketingOpen, isFunctionalOpen, showConsentModal, publicResources, isOptionsOpen } = this.state;

        if (!showConsentModal) {
            return null;
        }

        return (
            publicResources && (
                <>
                    <div
                        className="modal show d-block"
                        id="consentModal"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="consentModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h2 id="cf_modal_title">{publicResources.mainTitle}</h2>
                                </div>
                                <div className="modal-body">
                                    <p className="cf-consent-intro">
                                        {publicResources.mainText}
                                    </p>
                                    <div className={`cf_consent-options ${isOptionsOpen ? 'd-block' : 'd-none'}`}>
                                        <hr />
                                        <ul className="cf-consent-container">
                                            <li className={`cf-consent-element ${isEssentialOpen ? 'cf-consent-elementBorder' : ''}`}>
                                                <button
                                                    type="button"
                                                    onClick={() => this.toggleSection('isEssentialOpen')}
                                                    className="cf-consent-element__button"
                                                >
                                                    <div className="cf-consent-element__checkbox-wrapper filtersModal--checkbox">
                                                        <input type="checkbox" data-purpose-id="uNFh" className="cf-checkbox" id="checkbox-1" checked={true} disabled={true} />
                                                    </div>
                                                    <div className="w-100">
                                                        <h3 className="dropdown-title">
                                                            {publicResources.essentialTitle} {isEssentialOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                                        </h3>
                                                        {isEssentialOpen && (
                                                            <p>
                                                                {publicResources.essentialText}
                                                            </p>
                                                        )}
                                                    </div>
                                                </button>
                                            </li>

                                            <li className={`cf-consent-element ${isMarketingOpen ? 'cf-consent-elementBorder' : ''}`}>
                                                <button
                                                    type="button"
                                                    onClick={() => this.toggleSection('isMarketingOpen')}
                                                    className="cf-consent-element__button"
                                                >
                                                    <div className="cf-consent-element__checkbox-wrapper filtersModal--checkbox">
                                                        <input
                                                            type="checkbox"
                                                            data-purpose-id="KlIi"
                                                            className="cf-checkbox"
                                                            id="checkbox-0"
                                                            checked={marketingConsent}
                                                            onChange={() => this.setState({ marketingConsent: !marketingConsent })}
                                                        />
                                                    </div>
                                                    <div className="w-100">
                                                        <h3 className="dropdown-title">
                                                            {publicResources.marketingTitle} {isMarketingOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                                        </h3>
                                                        {isMarketingOpen && (
                                                            <p>
                                                                {publicResources.marketingText}
                                                            </p>
                                                        )}
                                                    </div>
                                                </button>
                                            </li>

                                            <li className={`cf-consent-element ${isFunctionalOpen ? 'cf-consent-elementBorder' : ''}`}>
                                                <button
                                                    type="button"
                                                    onClick={() => this.toggleSection('isFunctionalOpen')}
                                                    className="cf-consent-element__button"
                                                >
                                                    <div className="cf-consent-element__checkbox-wrapper filtersModal--checkbox">
                                                        <input
                                                            type="checkbox"
                                                            data-purpose-id="ulGI"
                                                            className="cf-checkbox"
                                                            id="checkbox-2"
                                                            checked={functionalConsent}
                                                            onChange={() => this.setState({ functionalConsent: !functionalConsent })}
                                                        />
                                                    </div>
                                                    <div className="w-100">
                                                        <h3 className="dropdown-title">
                                                            {publicResources.functionalTitle} {isFunctionalOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                                        </h3>
                                                        {isFunctionalOpen && (
                                                            <p>
                                                                {publicResources.functionalText}
                                                            </p>
                                                        )}
                                                    </div>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    {isOptionsOpen ? (
                                        <>
                                            <button
                                                type="button"
                                                className="cf-button cf-button--save"
                                                id="cf_consent-buttons__save"
                                                onClick={this.handleSave}
                                            >
                                                {publicResources.confirmButtonText}
                                            </button>
                                            <button
                                                type="button"
                                                className="cf-button cf-button--reject"
                                                id="cf_consent-buttons__reject-all"
                                                onClick={this.handleRejectAll}
                                            >
                                                {publicResources.rejectAllButtonText}
                                            </button>
                                        </>
                                    ) : (
                                        <button
                                            type="button"
                                            className="cf-button cf-button--options"
                                            id="cf_consent-buttons__options"
                                            onClick={this.handleOptions}
                                        >
                                            {publicResources.settingsButtonText}
                                        </button>

                                    )}
                                    <button
                                        type="button"
                                        className="cf-button cf-button--accept"
                                        id="cf_consent-buttons__accept-all"
                                        onClick={this.handleAcceptAll}
                                    >
                                        {publicResources.acceptAllButtonText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop show" />
                </>
            )
        );
    }
}
